import { Component, h, Prop, State, Host } from '@stencil/core';
import state from '@ugc-store';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { LinedInfo } from '../../icons';

@Component({
  tag: 'ugc-info-tooltip',
  styleUrl: 'ugc-info-tooltip.scss',
  shadow: false,
})
export class UgcInfoTooltip {
  @Prop() header?: string = '';
  @Prop() content: string = '';
  @Prop() closeText: string = '';
  @Prop() tooltipName: string = '';
  @State() isOpen: boolean = false;
  @Prop() interactive?: boolean = false;
  @Prop() iconSize?: string = '20px';

  handleOpen = e => {
    e.stopPropagation();
    this.isOpen = true;
  };

  handleClose = e => {
    e.stopPropagation();
    this.isOpen = false;
  };

  render() {
    const { isDesktop } = state;
    if (isDesktop)
      return (
        <ugc-tooltip content={this.content} interactive={this.interactive} name={this.tooltipName}>
          <i class="info-icon-wrap inline-flex">
            <LinedInfo width={this.iconSize} height={this.iconSize} />
          </i>
        </ugc-tooltip>
      );

    return (
      <Host>
        <i class={`flex ${this.isOpen ? 'ugc-tooltip-open' : ''}`}>
          <i class={`info-icon-wrap inline-flex`} onClick={this.handleOpen}>
            <LinedInfo width={this.iconSize} height={this.iconSize} />
          </i>
        </i>
        <ugc-modal-dialog
          isShow={this.isOpen}
          isShowCloseButton={false}
          zIndex={modalZIndex['ugc-info-toolTip']}
          handleCancel={this.handleClose}
        >
          {this.isOpen && (
            <div class="pt-16 pb-24 px-24">
              {this.header && <h4 class="fs-20 lh-32 mt-0 mb-12">{this.header}</h4>}
              <p class="fs-16 lh-24 my-6 mb-16 word-break link-blue-dark" innerHTML={this.content} />
              <ugc-button height="48" type="ghost" fontSize="16" onClick={this.handleClose}>
                {this.closeText}
              </ugc-button>
            </div>
          )}
        </ugc-modal-dialog>
      </Host>
    );
  }
}
